import type { ReactNode } from 'react'
import { useRoles, hasRole, type Role } from '@/components/common/roles'

// Renders children only if the user holds one of the required roles.
export function RoleGate({
  required,
  children,
  fallback = null,
}: {
  required: Role | Role[]
  children: ReactNode
  fallback?: ReactNode
}) {
  const roles = useRoles()
  return <>{hasRole(roles, required) ? children : fallback}</>
}
